import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';
import snippetImage from '../assets/projectsImages/snippet.png';
import portfolioImage from '../assets/projectsImages/PersonalPortfolio.png';
import stormyWeatherApp from '../assets/projectsImages/StormyWeather.png';
import TTSite from '../assets/projectsImages/ttSite.png';
import Admin from '../assets/projectsImages/admin.png';
import Checkout from '../assets/projectsImages/checkout.png';
import DNA from '../assets/projectsImages/DNA.png';

export default function Projects() {
    return (
        <div className="projectsSection" id="projects">
            <div className="projectsContainer">
                <div className="innerProjectsContainer">
                    <div className="projectsTitling">
                        <p className="projectsTitle">PROJECTS</p>
                    </div>
                    <div className="projectsGrids">
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={snippetImage} alt="Snippet Weather and Itinerary App"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">Snippet</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    Snippet was developed for CPSC-491 Senior Capstone Project. This application aims to provide a 'snippet' of hyper-local weather and acitivity information in the cleanest and simplest way possible. Snippet grabs relevant weather & atmospheric conditions and displays them with relevent locations and/or activities provided by both Google Maps and Yelp Fusion.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">React.js</p>
                                        <p className="stackTools">Node.js</p>
                                        <p className="stackTools">JavaScript</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera/Snippet-WeatherSite-CPSC491">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={portfolioImage} alt="Spencer DeMera's Portfolio"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">My Portfolio</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    The site's main structure was primarily built out in vanilla HTML, CSS, and Javascript within React.js, which was used for better overall structure. After initial designing in Figma and construction in VS Code, the site is currently hosted on GitHub Pages. This site is meant to be my own digital portfolio for my devlopment skills.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Figma</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">React.js</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera/SpencerDeMera-Personal-Portfolio-RawReactCode">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={stormyWeatherApp} alt="StormyWeather Build 0.5.2 Beta"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">StormyWeather App</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    StormyWeather is my own take on a weather app that is simple and clean while still providing detailed hourly and daily forecasts. This app was developed with the OpenWeather OneCall™ API to ensure simple and accurate atmospheric weather forecast data. This app is currently in development primarily for Android and later iOS.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Figma</p>
                                        <p className="stackTools">OpenWeather&nbsp;API</p>
                                        <p className="stackTools">React-Native</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={TTSite} alt="CSUF Theta Tau Phi Epsilon Chapter Website"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">CSUF Theta Tau Website</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    This is the official website of Cal State Fullerton's Theta Tau Chapter, Phi Epsilon. This site was theorized and designed by a team of Phi Epsilon actives lead by myself over the course of the Spring 2021 semester. The majority of the site was built by myself using vanilla HTML, CSS, Javascript and (in the future) PHP.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">Figma</p>
                                        <p className="stackTools">HTML/CSS</p>
                                        <p className="stackTools">JavaScript</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/CSUFThetaTau-web/CSUFThetaTau-web.github.io">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={DNA} alt="DNA Translation Program"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">DNA Transcriber/Translator</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    Project is meant as a fun exploration of genetic material manipulation as well as transcription and translation using C++. This system takes a strand of DNA as input and allows for transcribing it to RNA, finding the complement of both the DNA and RNA, reversing the DNA and RNA, as well as translating the DNA and RNA to a protein. System is terminal based and relies on menu navigation via numerical input from the command line.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">C/C++</p>
                                        <p className="stackTools">Shell</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera/DNA-Transcriber-Translator">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={Admin} alt="University Administration System"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">University Admin System</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    Project meant as a theoretical exploration of what a school administration system might look like if written in C++. Program makes use of various crucial data structures such as; Lists, Dictionaries, ArrayLists, and ArrayList Dictionaries. System is terminal based and relies on menu navigation via numerical input from the command line. Systems relies on theoretical values for school metrics.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">C++</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera/School-Admin-System">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="projects">
                            <div id="projectImg" href="#"><img src={Checkout} alt="Hardware Store Checkout System"></img></div>
                            <div className="projectInner">
                                <p className="projectIndivTitle">Store Checkout System</p>
                                <div className="projectsBar"></div>
                                <p className="projectsDescriptText">
                                    Project meant as a theoretical exploration and recreation of various checkout inventory systems observed as being used by some stores such as Lowes. System mimics that of such stores in both functionality and physical appearance to a close degree (provided the limited knowledge of true system functionality of the real systems) and explores what it might look like if written in C++.
                                </p>
                                <p className="stackTitle">Stack</p>
                                <div className="stackGrid">
                                    <div className="innerStackGrid">
                                        <p className="stackTools">C++</p>
                                    </div>
                                </div>
                                <div className="codebuttonContainer">
                                    <div className="codeButton">
                                        <a className="codeBtn" target="_blank" href="https://github.com/SpencerDeMera/Hardware-Store-Checkout-System">Source Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
